import React from 'react';

import './index.less';

export interface InteractionProps {
	checked: boolean;
	handleChange: (checked: boolean) => void;
}

export interface Props extends InteractionProps {
	iconUrl: string;
	title: string;
	description: string;
	background: string;
	className?: string;
}

export const CheckboxBanner: React.SFC<Props> = ({
	checked,
	handleChange,
	iconUrl,
	title,
	description,
	background,
	className
}) => (
	<div
		className={`CheckboxBanner ${className ? className : ''}`}
		onClick={() => {
			handleChange(!checked);
		}}
		style={{ background }}
	>
		{title}
		<img src={iconUrl} className="CheckboxBanner__image" />
		<div className="CheckboxBanner__description">{description}</div>
		<div className="CheckboxBanner__inputWrapper">
			<input
				type="checkbox"
				checked={checked}
				onChange={event => {
					const { target } = event;
					handleChange(target.checked);
				}}
			/>
		</div>
	</div>
);
